import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";

/**
 * options for formErrorClass:
 * form-error (default)
 * form-error-inverse
 *  */

function ErrorLabel({ errorKey, errors, formErrorClass = "form-error" }) {
  const [formErrorClassName, setFormErrorClassName] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormErrorMessage("");
    if (
      hasProperty(errors, "response.data.data.errors") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormErrorClassName(`form-error ${formErrorClass}`);
          setFormErrorMessage(iterator.message);
          break;
        }
      }
    }
  }, [errorKey, errors, formErrorClass]);

  return (
    <>
      {formErrorMessage && (
        <div className={formErrorClassName}>{formErrorMessage}</div>
      )}
    </>
  );
}

ErrorLabel.propTypes = {
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired,
  formErrorClass: PropTypes.string
};

export default ErrorLabel;
